import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import React from "react"

interface LogoProps {
  alt: string
}

export const Logo: React.FC<LogoProps> = ({ alt }) => {
  const data = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          fixed(width: 120) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)
  return <Img fixed={data.logo.childImageSharp.fixed} alt={alt} />
}
